// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.YouTubeVideoCard_scroll__FeHCs::-webkit-scrollbar {
  height: 8px;
}
.YouTubeVideoCard_scroll__FeHCs::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.YouTubeVideoCard_scroll__FeHCs::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.YouTubeVideoCard_YouTubeVideoCard__ts3Cs {
  font-family: chirp;
  height: 100%;
  /*   margin-bottom: 20px; */
  flex-direction: column;
  background-color: var(--bgColor);
  position: relative;
  width: 100%;
  color: var(--mainColor);
}
.YouTubeVideoCard_YouTubeVideoCard_Container__AL93Z {
  border-radius: 3px;
  border: 1px solid var(--borderColor);
}
.YouTubeVideoCard_YouTubeVideoCard_Container_content__vTRK3 {
  padding: 10px 10px 0;
}

.YouTubeVideoCard_youtube_thumbnail__wrP0k {
  position: relative;
  width: 100%;
  text-align: center;
}
.YouTubeVideoCard_youtube_thumbnail__wrP0k img {
  width: 100%;
  object-fit: cover;
  border-radius: 16px;
  display: block;
}
.YouTubeVideoCard_youtube_thumbnail__wrP0k .YouTubeVideoCard_VideoBtn__J5RZ2 {
  cursor: pointer;
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--bgColor);
  width: 37px;
  height: 37px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--secondaryColor);
}

.YouTubeVideoCard_youtubePostCardStatus__kOUii {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-top: 1px solid var(--borderColor);
  margin-top: 10px;
  font-family: inherit;
}
.YouTubeVideoCard_youtubePostCardStatus__kOUii div {
  width: 40%;
  max-width: 100px;
  font-size: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  text-align: start;
  justify-content: center;
}
.YouTubeVideoCard_youtubePostCardStatus__kOUii div span:first-child {
  color: var(--tweetSubTitleColor);
  text-transform: capitalize;
}
.YouTubeVideoCard_youtubePostCardStatus__kOUii div span:last-of-type {
  font-weight: bold;
  color: var(--mainColor);
}

.YouTubeVideoCard_VideoPost__3jzHS h5 {
  font-size: 14px !important;
  margin-bottom: 5px;
}
body[dir=ltr] .YouTubeVideoCard_VideoPost__3jzHS h5 {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] .YouTubeVideoCard_VideoPost__3jzHS h5 {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}
.YouTubeVideoCard_VideoPost__3jzHS .YouTubeVideoCard_showLessDetails__vHz1N {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.YouTubeVideoCard_VideoPost__3jzHS .YouTubeVideoCard_videoPost_Text__LEoy6 {
  font-size: 10px !important;
  width: 100%;
  white-space: pre-line;
  overflow: hidden;
  margin-bottom: 20px;
  font-family: inherit;
  word-break: break-word;
  margin-top: 20px;
  font-weight: 400;
}
.YouTubeVideoCard_VideoPost__3jzHS .YouTubeVideoCard_showMoreDetailsToggle__B62zz {
  cursor: pointer;
}
.YouTubeVideoCard_VideoPost__3jzHS .MuiAccordion-rounded {
  border: 0;
}
.YouTubeVideoCard_VideoPost__3jzHS .MuiAccordion-root:before {
  background: none;
}
.YouTubeVideoCard_VideoPost__3jzHS .MuiAccordionSummary-root {
  gap: 5px;
  min-height: 0;
  min-height: initial;
  margin: 0;
}
.YouTubeVideoCard_VideoPost__3jzHS .MuiIconButton-label svg path {
  fill: var(--secondaryColor);
}
.YouTubeVideoCard_VideoPost__3jzHS .MuiAccordionSummary-root.Mui-expanded {
  min-height: 0;
  min-height: initial;
}
.YouTubeVideoCard_VideoPost__3jzHS .MuiAccordionSummary-content {
  justify-content: center;
  color: var(--secondaryColor);
  text-transform: capitalize;
  flex-grow: 0;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/YouTubeVideoCard/YouTubeVideoCard.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,kBAAA;EACA,YAAA;EACF,2BAAA;EACE,sBAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;AAsDF;AArDE;EACE,kBAAA;EACA,oCAAA;AAuDJ;AAtDI;EACE,oBAAA;AAwDN;;AAnDA;EACE,kBAAA;EACA,WAAA;EAOA,kBAAA;AAgDF;AAtDE;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAwDJ;AArDE;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;AAuDJ;;AAnDA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,wCAAA;EACA,gBAAA;EACA,oBAAA;AAsDF;AArDE;EACE,UAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,uBAAA;AAuDJ;AArDI;EACE,gCAAA;EACA,0BAAA;AAuDN;AArDI;EACE,iBAAA;EACA,uBAAA;AAuDN;;AAlDE;EDkCE,0BAAA;EChCA,kBAAA;AAqDJ;ADpBI;EACE,2DAAA;ACsBN;ADpBI;EACE,2DAAA;ACsBN;AAzDE;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AA2DJ;AAzDE;EDoBE,0BAAA;EClBA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AA2DJ;AAzDE;EACE,eAAA;AA2DJ;AAxDI;EACE,SAAA;AA0DN;AAxDI;EACE,gBAAA;AA0DN;AAxDI;EACE,QAAA;EACA,aAAA;EAAA,mBAAA;EACA,SAAA;AA0DN;AAtDQ;EACE,2BAAA;AAwDV;AApDI;EACE,aAAA;EAAA,mBAAA;AAsDN;AAjDI;EACE,uBAAA;EACA,4BAAA;EACA,0BAAA;EACA,YAAA;EACA,SAAA;AAmDN","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.YouTubeVideoCard {\n  font-family: chirp;\n  height: 100%;\n/*   margin-bottom: 20px; */\n  flex-direction: column;\n  background-color: var(--bgColor);\n  position: relative;\n  width: 100%;\n  color: var(--mainColor);\n  &_Container {\n    border-radius: 3px;\n    border: 1px solid var(--borderColor);\n    &_content {\n      padding: 10px 10px 0;\n    }\n  }\n}\n\n.youtube_thumbnail {\n  position: relative;\n  width: 100%;\n  img {\n    width: 100%;\n    object-fit: cover;\n    border-radius: 16px;\n    display: block;\n  }\n  text-align: center;\n  .VideoBtn {\n    cursor: pointer;\n    position: absolute;\n    display: block;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: var(--bgColor);\n    width: 37px;\n    height: 37px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--secondaryColor);\n  }\n}\n\n.youtubePostCardStatus {\n  display: flex;\n  align-items: center;\n  padding: 10px 0;\n  border-top: 1px solid var(--borderColor);\n  margin-top: 10px;\n  font-family: inherit;\n  div {\n    width: 40%;\n    max-width: 100px;\n    font-size: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    text-align: start;\n    justify-content: center;\n\n    span:first-child {\n      color: var(--tweetSubTitleColor);\n      text-transform: capitalize;\n    }\n    span:last-of-type {\n      font-weight: bold;\n      color: var(--mainColor);\n    }\n  }\n}\n.VideoPost {\n  h5 {\n    @include fontSize(14);\n    margin-bottom: 5px;\n  }\n  .showLessDetails {\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n  .videoPost_Text {\n    @include fontSize(10);\n    width: 100%;\n    white-space: pre-line;\n    overflow: hidden;\n    margin-bottom: 20px;\n    font-family: inherit;\n    word-break: break-word;\n    margin-top: 20px;\n    font-weight: 400;\n  }\n  .showMoreDetailsToggle {\n    cursor: pointer;\n  }\n  :global {\n    .MuiAccordion-rounded {\n      border: 0;\n    }\n    .MuiAccordion-root:before {\n      background: none;\n    }\n    .MuiAccordionSummary-root {\n      gap: 5px;\n      min-height: unset;\n      margin: 0;\n    }\n    .MuiIconButton-label {\n      svg {\n        path {\n          fill: var(--secondaryColor);\n        }\n      }\n    }\n    .MuiAccordionSummary-root.Mui-expanded {\n      min-height: unset;\n    }\n    // .MuiAccordionSummary-content.Mui-expanded {\n    //   margin: 0;\n    // }\n    .MuiAccordionSummary-content {\n      justify-content: center;\n      color: var(--secondaryColor);\n      text-transform: capitalize;\n      flex-grow: 0;\n      margin: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `YouTubeVideoCard_scroll__FeHCs`,
	"YouTubeVideoCard": `YouTubeVideoCard_YouTubeVideoCard__ts3Cs`,
	"YouTubeVideoCard_Container": `YouTubeVideoCard_YouTubeVideoCard_Container__AL93Z`,
	"YouTubeVideoCard_Container_content": `YouTubeVideoCard_YouTubeVideoCard_Container_content__vTRK3`,
	"youtube_thumbnail": `YouTubeVideoCard_youtube_thumbnail__wrP0k`,
	"VideoBtn": `YouTubeVideoCard_VideoBtn__J5RZ2`,
	"youtubePostCardStatus": `YouTubeVideoCard_youtubePostCardStatus__kOUii`,
	"VideoPost": `YouTubeVideoCard_VideoPost__3jzHS`,
	"showLessDetails": `YouTubeVideoCard_showLessDetails__vHz1N`,
	"videoPost_Text": `YouTubeVideoCard_videoPost_Text__LEoy6`,
	"showMoreDetailsToggle": `YouTubeVideoCard_showMoreDetailsToggle__B62zz`
};
export default ___CSS_LOADER_EXPORT___;
